import { createFileRoute } from '@tanstack/react-router';
import { useSession } from '../hooks/auth/useSession';
import ProfileCard from '../components/ProfileCard';

export const Route = createFileRoute('/profile')({
  component: RouteComponent,
});

function RouteComponent() {
  const { session, loading, isAuthenticated } = useSession();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="flex flex-col items-center space-y-4">
          <div className="border-primary h-10 w-10 animate-spin rounded-full border-b-2"></div>
          <p className="text-sm text-gray-500">Loading profile...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !session) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-lg text-gray-500">Please log in to view your profile.</p>
      </div>
    );
  }

  return (
    <div className="mx-auto flex flex-col items-center justify-center py-8">
      <ProfileCard />
    </div>
  );
}
